import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import {SecondaryNavigation} from 'components/Navigation';
import ActiveImageSetVersionList from './ActiveImageSetVersionList';

const ReadingReactions = () => {
  return (
    <React.Fragment>
      <SecondaryNavigation
        tabs={[
          {url: '/misc/active-image-set-versions', label: 'Active Image Set Version', isActive: true},
          {url: '/misc/reading-reactions', label: 'Reading Reactions', isActive: false},
          {url: '/misc/user-avatars', label: 'Users Avatars', isActive: false},
        ]}
      />
      <Switch>
        <Route path="/misc/active-image-set-versions" component={ActiveImageSetVersionList} />
        <Redirect to="/misc/active-image-set-versions" />
      </Switch>
    </React.Fragment>
  );
};

export default ReadingReactions;
